import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentLinkExpiredComponent } from './components/payment-link-expired/payment-link-expired.component';
import { PaymentLinkErrorComponent } from './components/payment-link-error/payment-link-error.component';
import { PaymentLinkLandingContainerComponent } from './components/payment-link-landing/payment-link-landing-container.component';

const routes: Routes = [
  {
    path: 'expired',
    component: PaymentLinkExpiredComponent,
  },
  {
    path: 'error',
    component: PaymentLinkErrorComponent,
  },
  {
    path: ':paymentLinkToken',
    component: PaymentLinkLandingContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentLinksRoutingModule {}
